import { Input } from '@eliadmin/core/src/components/ui/input';
import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

export function AttributePrice() {
  const max = useCategoryStore(state => state.category.price.max);
  const min = useCategoryStore(state => state.category.price.min) ?? 0;
  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const [priceRange, setPriceRange] = React.useState<number[]>([0, max ?? 100000]);

  const setFilter = useCategoryStore(state => state.setFilter);

  React.useEffect(() => {
    setPriceRange([0, max ?? 100000]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTrigger]);

  const handlePriceChange = () => {
    setFilter({ price_min: priceRange[0], price_max: priceRange[1] });
  };

  if (max === null) return null;

  return (
    <div className={cn('flex flex-col gap-4 py-2 ', 'ea-attribute-price')}>
      <Slider
        isDual
        value={priceRange}
        min={min}
        max={max}
        aria-label="Price range"
        onValueChange={value => setPriceRange(value)}
        onBlur={handlePriceChange}
        className=""
      />
      <div
        className={cn('flex w-full flex-row justify-between gap-2', 'ea-attribute-price__wrapper')}
      >
        <Input
          className={{ wrapper: cn('flex-1', 'ea-attribute-radio__input-min') }}
          name={'min'}
          variant={'outlined'}
          value={priceRange[0]}
          disabled
        />
        <Input
          className={{ wrapper: cn('flex-1', 'ea-attribute-radio__input-max') }}
          name={'max'}
          variant={'outlined'}
          value={priceRange[1]}
          disabled
        />
      </div>
    </div>
  );
}
